var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 0C17.474423 0 15 2.4744232 15 5.5L15 6L14 6L14 8L18 8L18 6L17 6L17 5.5C17 3.5555768 18.555577 2 20.5 2C22.444423 2 24 3.5555768 24 5.5L24 17L22 17L22 14L18 14L19 17L3.6914062 17L4.0351562 18.263672C5.8019782 24.742351 11.475716 29.209971 18.072266 29.779297L20.095703 50L29.904297 50L29.994141 49.099609L31.927734 29.779297C38.524284 29.209971 44.198022 24.742351 45.964844 18.263672L46.308594 17L31 17L32 14L28 14L28 17L26 17L26 5.5C26 2.4744232 23.525577 0 20.5 0 z M 6.546875 19L43.453125 19C41.401937 24.329141 36.40619 28 30.597656 28L19.402344 28C13.59381 28 8.5980626 24.329141 6.546875 19 z M 20.103516 30L29.896484 30L28.095703 48L21.904297 48L20.103516 30 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSink);
export default __webpack_public_path__ + "static/media/sink.d7aa1054092681713b92d7a364d01750.svg";
export { ForwardRef as ReactComponent };